import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import React from 'react';
import '../hooks/useDetectInputMethod.js';
import { useId } from '@reach/auto-id';
import { useTheme } from '../hooks/useTheme.js';
import { Box } from '../Box/index.js';
import { useButtonGroup } from './useButtonGroup.js';

var ButtonGroup = function (_a) {
    var children = _a.children, _b = _a.defaultSelected, defaultSelected = _b === void 0 ? "" : _b, _c = _a.name, name = _c === void 0 ? "" : _c, onChange = _a.onChange, _d = _a.rounded, rounded = _d === void 0 ? false : _d, _e = _a.size, size = _e === void 0 ? "md" : _e, forwardProps = __rest(_a, ["children", "defaultSelected", "name", "onChange", "rounded", "size"]);
    var _f = useButtonGroup({
        defaultSelected: defaultSelected,
        onChange: onChange,
    }), selected = _f.selected, handleOnClick = _f.handleOnClick;
    var handleStyleProps = useTheme().handleStyleProps;
    var buttonGroupStyleProps = handleStyleProps(__assign({ rounded: rounded, size: size }, forwardProps), {
        themeKey: "buttonGroup",
    });
    return (jsx(Box, __assign({ name: name, role: "group" }, buttonGroupStyleProps, { children: React.Children.map(children, function (child) {
            if (React.isValidElement(child)) {
                var _a = child.props, idProp = _a.id, _b = _a.look, lookProp = _b === void 0 ? "primary" : _b, _c = _a.name, nameProp = _c === void 0 ? name : _c, onClickProp = _a.onClick, _d = _a.rounded, roundedProp = _d === void 0 ? false : _d, sizeProp = _a.size;
                var id = idProp ? "".concat(idProp) : "button-".concat(useId());
                var look = selected.id === id ? lookProp : "naked";
                var onClick = handleOnClick(id, onClickProp);
                return React.cloneElement(child, {
                    look: look,
                    name: nameProp,
                    onClick: onClick,
                    rounded: rounded || roundedProp,
                    size: size || sizeProp,
                });
            }
            return child;
        }) })));
};
ButtonGroup.displayName = "ButtonGroup";

export { ButtonGroup };
//# sourceMappingURL=ButtonGroup.js.map
